import { useParams } from 'react-router-dom';
import { SubPageLayout } from '../../../../sub-page-layout';
import { getItem } from '../../../../../../../shared/local-storage.ts';
import { CaseDetailsMessagesContainer } from '../components/case-details-messages-container.tsx';
import { Helmet } from 'react-helmet';

export const MessagesCredCase: React.FC = () => {
  const params = useParams();
  const applicantUserId = getItem('applicantUserId');
  return (
    <>
      <Helmet>
        <title>Case - Messages</title>
      </Helmet>
      <SubPageLayout>
        <CaseDetailsMessagesContainer caseId={params['caseId'] ?? ''} applicantId={applicantUserId ?? ''} />
      </SubPageLayout>
    </>
  );
};
